<template>
  <div class="wrapper">
    <b-tabs content-class="mt-3">
      <b-tab title="Evenements" >
        <AdminEvent/>
      </b-tab>
      <b-tab title="Membres" active>
        <AdminUser/>
      </b-tab>
      <b-tab title="Jeux">
        <AdminJeux/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import AdminUser from '@/components/admin/AdminUser'
import AdminEvent from '@/components/admin/AdminEvent'
import AdminJeux from '@/components/admin/AdminJeux'
export default {
  name: 'AdminView',
  components:{
    AdminUser,
    AdminEvent,
    AdminJeux,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.wrapper{
  margin: 25px;
}

</style>
